/* eslint-disable max-len */
import { MasterQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig/models";

import * as questionIds from "./questionIds";

export const masterConfig: MasterQuestionConfig[] = [
    // Data Privacy
    {
        id: questionIds.PrivacyConsent,
        questionText: "I have been provided with access to the <a href=\"https://www.tphealth.co.uk/privacy-statement\" target=\"_blank\" rel=\"noopener noreferrer\">Optima Health Privacy Statement</a> which clearly explains in detail how, where and when their personal and health data will be processed.",
        canBeDisabled: true
    },
    {
        id: questionIds.DataSecureConsent,
        questionText: "I understand that any information I provide in this form will be held securely in electronic format by Optima Health and that if I wish to request access to any information that is being held about me I can do so by writing to Optima Health.",
        canBeDisabled: true
    },
    // Employee Details
    {
        id: questionIds.JobTitle,
        questionText: "Job Role/Title",
        canBeDisabled: true
    },
    {
        id: questionIds.Postcode,
        questionText: "Postcode",
        canBeDisabled: false
    },
    {
        id: questionIds.MobilePhone,
        questionText: "Mobile Telephone Number",
        canBeDisabled: true
    },
    {
        id: questionIds.HomePhone,
        questionText: "Home Telephone Number",
        canBeDisabled: true
    },
    {
        id: questionIds.EmployeeId,
        questionText: "Employee Unique Id",
        canBeDisabled: true
    },
    {
        id: questionIds.OrgLevel1Name,
        questionText: "Org Level 1",
        canBeDisabled: true
    },
    {
        id: questionIds.OrgLevel2Name,
        questionText: "Org Level 2",
        canBeDisabled: true
    },
    {
        id: questionIds.OrgLevel3Name,
        questionText: "Org Level 3",
        canBeDisabled: true
    },
    {
        id: questionIds.OrgLevel4Name,
        questionText: "Org Level 4",
        canBeDisabled: true
    },
    // Reason for Referral
    {
        id: questionIds.AbsenceReason,
        questionText: "Please explain the reason why you are requesting direct access to Physiotherapy",
        canBeDisabled: true
    },
    {
        id: questionIds.BodyPartAffected,
        questionText: "Body Part affected",
        canBeDisabled: true
    },
    {
        id: questionIds.CurrentWorkStatus,
        questionText: "Are you currently at work or off work?",
        canBeDisabled: true
    },
    {
        id: questionIds.FirstDayOfAbsence,
        questionText: "First day of absence",
        canBeDisabled: true
    },
    {
        id: questionIds.AdditionalInformation,
        questionText: "Any additional information",
        canBeDisabled: true
    },
    // Attachments
    {
        id: questionIds.Attachments,
        questionText: "Attach any documents",
        canBeDisabled: true
    },
    {
        id: questionIds.PurchaseOrderNumber,
        questionText: "Purchase Order Number",
        canBeDisabled: true,
        disabled: true
    }
];
